 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-de":"lang-de","lang-es":"lang-es","lang-fr":"lang-fr","lang-it":"lang-it","lang-zh":"lang-zh","lang-zh-CN":"lang-zh-CN"}[chunkId]||chunkId) + "." + {"chunk-011d1702":"43f53b9d","chunk-01ed813b":"560f3c07","chunk-0a130a7a":"ef46bfc2","chunk-0abdfb58":"fc694382","chunk-0caaeca4":"bdf4600b","chunk-0fec6726":"41a9e999","chunk-1f09fc3b":"85b0dafc","chunk-2950e3dd":"542e603c","chunk-2c6a7081":"c6c2966c","chunk-318df0bb":"36b13fe2","chunk-39fa456e":"acfa1d7f","chunk-3a31d2cc":"023a6f58","chunk-45dbb7bb":"ffa20cd8","chunk-4779459b":"4665802e","chunk-486375c7":"9c345112","chunk-5c9385e6":"8680d421","chunk-6618444b":"ae738e5c","chunk-6a36134d":"2bd1ad3f","chunk-740a063f":"e05f0d0c","chunk-7569d660":"5575c26f","chunk-77be0389":"e5973c19","chunk-82a526cc":"970d4dd1","chunk-95acc94c":"e3dab00a","chunk-a02411de":"0c326e63","chunk-a9ce97e2":"bb62614d","chunk-b3b17320":"2ebfaa88","chunk-bb87e81a":"464646ec","chunk-f97cc698":"16c7768d","chunk-ff163bb2":"dd968870","lang-de":"9959830c","lang-es":"0a3ddc93","lang-fr":"b2da6018","lang-it":"46a62e63","lang-zh":"d30cea41","lang-zh-CN":"5ed20c0e","chunk-66083204":"71c70ceb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-011d1702":1,"chunk-01ed813b":1,"chunk-0a130a7a":1,"chunk-0abdfb58":1,"chunk-0caaeca4":1,"chunk-0fec6726":1,"chunk-1f09fc3b":1,"chunk-2950e3dd":1,"chunk-2c6a7081":1,"chunk-318df0bb":1,"chunk-39fa456e":1,"chunk-3a31d2cc":1,"chunk-45dbb7bb":1,"chunk-4779459b":1,"chunk-486375c7":1,"chunk-5c9385e6":1,"chunk-6618444b":1,"chunk-6a36134d":1,"chunk-740a063f":1,"chunk-7569d660":1,"chunk-77be0389":1,"chunk-82a526cc":1,"chunk-95acc94c":1,"chunk-a02411de":1,"chunk-a9ce97e2":1,"chunk-b3b17320":1,"chunk-bb87e81a":1,"chunk-f97cc698":1,"chunk-ff163bb2":1,"chunk-66083204":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-de":"lang-de","lang-es":"lang-es","lang-fr":"lang-fr","lang-it":"lang-it","lang-zh":"lang-zh","lang-zh-CN":"lang-zh-CN"}[chunkId]||chunkId) + "." + {"chunk-011d1702":"7222e3c1","chunk-01ed813b":"c104077a","chunk-0a130a7a":"08814820","chunk-0abdfb58":"605a4f99","chunk-0caaeca4":"668de9e3","chunk-0fec6726":"0f5c85a7","chunk-1f09fc3b":"e008b9bf","chunk-2950e3dd":"718c199b","chunk-2c6a7081":"9e963f73","chunk-318df0bb":"1da817a4","chunk-39fa456e":"44a7f9c3","chunk-3a31d2cc":"b426061f","chunk-45dbb7bb":"5164afd2","chunk-4779459b":"92389601","chunk-486375c7":"49b0175b","chunk-5c9385e6":"82757564","chunk-6618444b":"52a64dbc","chunk-6a36134d":"71c7d852","chunk-740a063f":"597b422a","chunk-7569d660":"5307f4fc","chunk-77be0389":"ecb99639","chunk-82a526cc":"2d6e4cb7","chunk-95acc94c":"4ee96156","chunk-a02411de":"ef7a1f11","chunk-a9ce97e2":"30a69e0f","chunk-b3b17320":"99ac299b","chunk-bb87e81a":"f6030544","chunk-f97cc698":"1c6e4d88","chunk-ff163bb2":"3c388219","lang-de":"31d6cfe0","lang-es":"31d6cfe0","lang-fr":"31d6cfe0","lang-it":"31d6cfe0","lang-zh":"31d6cfe0","lang-zh-CN":"31d6cfe0","chunk-66083204":"cadfadcc"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
